// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__ICLBk","contents":"style_contents__uPuKM","img":"style_img__FNa87"};